import React, { useEffect, useState } from "react";
import {
  saveGlobalOption,
  saveOptionById,
} from "../../../../Redux/actions/projectActions";
import { useDispatch, useSelector } from "react-redux";
import "./ScreenOption.css";
import { FaChevronDown, FaChevronUp } from "react-icons/fa";
import { toast } from "react-toastify";
import CustomToast, {
  customToatStyle,
} from "../../../../Components/CustomToast/CustomToast";
import { AiOutlineGlobal } from "react-icons/ai";

// Reusable Dropdown Component
const Dropdown = ({
  label,
  options,
  selectedValue,
  onSelect,
  formatOption,
  placeholder,
}) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="my-2">
      <div className="flex justify-between">
        {/* <label className="w-[70%] font-lable">{label}</label> */}
        <div className="ScreenRangeOptionLabel  cursor-help underline decoration-dashed decoration-[rgba(255,255,255,0.4)] underline-offset-4">{label}</div>
        <div className="relative flex items-center w-[30%] h-[36px] screen-dd-label">
          <div
            onClick={() => setIsOpen(!isOpen)}
            // className={`bg-[#ffffff0a] w-[8.2rem] cursor-pointer px-3 py-1 rounded flex  items-center justify-between text-white border-[1px] border-[#ffffff1b]`}

            className="w-full h-full flex justify-evenly items-center  resize-none bg-[#ffffff0b] outline-none border-[#ffffff14] border-[1px] rounded-xl text-[#f0eeff] px-[6px] py-[6px] font-normal text-[13px] "

          >
            <p className="text-center w-full">
              {selectedValue ? formatOption(selectedValue) : `${placeholder}`}
            </p>
            {!isOpen ? (
              <FaChevronDown className="text-[0.9rem]" />
            ) : (
              <FaChevronUp className="text-[0.9rem]" />
            )}
          </div>
          {isOpen && (
            <div
              className={`w-full absolute top-[2.5rem]  flex flex-col items-center  text-center rounded-lg overflow-y-scroll   bg-[#171329] border-[1px] border-[#ffffff1b] manrope-400 shadow-lg`}
              // style={{ top: "100%" }}
            >
              {options.map((option, idx) => (
                <li
                  key={idx}
                  className="w-[96%] py-1 hover:bg-[rgba(124,92,255,0.12)]  screenFirt text-sm manrope-400 cursor-pointer"
                  onClick={() => {
                    onSelect(option);
                    setIsOpen(false);
                  }}
                >
                  {formatOption(option)}
                </li>
              ))}
            </div>
          )}
        </div>
      </div>
      {selectedValue === "Fade" && (
        <div className="w-[52%]  Screenfont-lable">
          Fade In and Fade Out is included in the Screen duration when fade is
          selected.
        </div>
      )}
    </div>
  );
};

const SliderWithInput = ({ label, min, max, step, value, onChange }) => {
  const [localValue, setLocalValue] = useState(value);

  useEffect(() => {
    setLocalValue(value);
  }, [value]);

  const handleInputChange = (e) => {
    const inputValue = e.target.value;

    if (inputValue === "" || /^[0-9]*\.?[0-9]*$/.test(inputValue)) {
      const numericValue = parseFloat(inputValue);

      if (!isNaN(numericValue) && numericValue >= min && numericValue <= max) {
        setLocalValue(numericValue);
        onChange(numericValue);
      } else if (inputValue === "") {
        setLocalValue("");
      }
    }
  };

  const handleRangeChange = (e) => {
    const numericValue = parseFloat(e.target.value);
    setLocalValue(numericValue);
    onChange(numericValue); // Update the parent state
  };

  return (
    <div className="w-full h-[52px] py-[0.5rem] my-[15px] screenoptionSection">

      {/* <h2 className="text-[#f6f2ff] text-[13px] font-body font-medium">{label}</h2> */}
      <div className="ScreenRangeOptionLabel  cursor-help underline decoration-dashed decoration-[rgba(255,255,255,0.4)] underline-offset-4">{label}</div>
      
      <div className="flex justify-between items-center ScreenRangeOptionContent ">
        <div className=" w-[65%] sec">
          <input
            type="range"
            min={min}
            max={max}
            step={step}
            value={localValue || min}
            onChange={handleRangeChange}
            className="custom-range max-w-full"
          />
        </div>

        <div 
        // className="bg-[#ffffff0a]  w-[30%] flex justify-between items-center pr-2 rounded-md border-[1px] border-[#ffffff1b]"
        className="w-[30%] h-full flex justify-evenly items-center  resize-none bg-[#ffffff0b] outline-none border-[#ffffff14] border-[1px] rounded-xl text-[#f0eeff] px-[6px] py-[4px] font-normal text-[13px] screen-dd-label"
        >
          <input
            type="number"
            value={localValue}
            onChange={handleInputChange}
            className="text-[#f6f2ff] px-1 w-[50%] py-1 rounded text-center bg-[#ffffff0a] focusN focus:border-transparent focus:outline-none bg-[transparent]"
          />
          <span className="w-[40%]">sec</span>
        </div>
      </div>
    </div>
  );
};

const ScreenOption = ({
  currentBlockOptions,
  currentBlockIdx,
  currentBlockId,
  isCard,
}) => {
  const dispatch = useDispatch();

  const [singleScreenSettingOption, setSingleScreenSettingOption] = useState({
    screen_duration: currentBlockOptions.screen_duration || 1,
    transition_in: currentBlockOptions.transition_in || "",
    transition_in_duration: currentBlockOptions.transition_in_duration || 1,
    transition_out: currentBlockOptions.transition_out || "",
    transition_out_duration: currentBlockOptions.transition_out_duration || 1,
    delay: currentBlockOptions.delay || 0.4,
  });

  const [oneScreenDuration, setOneScreenDuration] = useState();

  useEffect(() => {
    setSingleScreenSettingOption({
      screen_duration: currentBlockOptions.screen_duration || 0,
      transition_in: currentBlockOptions.transition_in || "",
      transition_in_duration: currentBlockOptions.transition_in_duration || 0,
      transition_out: currentBlockOptions.transition_out || "",
      transition_out_duration: currentBlockOptions.transition_out_duration || 0,
      delay: currentBlockOptions.delay || 0,
    });
  }, [currentBlockIdx]);

  // By default, we save changes to the current card only
  const saveOptions = (currentBlockOptions, updatedOptions) => {
    dispatch(saveOptionById(currentBlockId, isCard, currentBlockOptions));
  };

  // Function to apply settings to all cards
  const applyToAll = () => {
    dispatch(saveGlobalOption(currentBlockId, singleScreenSettingOption));
    toast(
      <CustomToast title="" content="Changes applied to all screens." />,
      customToatStyle,
    );
  };

  useEffect(() => {
    Object.keys(currentBlockOptions).forEach((key) => {
      if (singleScreenSettingOption.hasOwnProperty(key)) {
        currentBlockOptions[key] = singleScreenSettingOption[key];
      }
    });
    const {
      screen_duration,
      transition_in,
      transition_in_duration,
      transition_out,
      transition_out_duration,
      delay,
    } = singleScreenSettingOption;

    const totalDuration = screen_duration + delay;

    setOneScreenDuration(totalDuration.toFixed(2));
  }, [singleScreenSettingOption, currentBlockOptions]);

  const handleOptionChange = (field, value) => {
    setSingleScreenSettingOption((prev) => {
      const updatedLocalOptions = { ...prev, [field]: value };
      currentBlockOptions[field] = value;
      saveOptions(currentBlockOptions);

      return updatedLocalOptions;
    });
  };

  return (
    <div className="h-full text-white transition-all duration-200 ease-in w-full overflow-y-auto">
      <div
        className="w-full  flex flex-col rounded-[15px] py-[0.5rem] px-[1.5rem] mt-[35px] mb-[20px] bg-[#191824]"
        style={{ border: "1px solid rgb(61, 61, 61)" }}
      >
        <SliderWithInput
          label="Screen Duration"
          min={0}
          max={10}
          step={0.1}
          value={singleScreenSettingOption.screen_duration}
          onChange={(value) => handleOptionChange("screen_duration", value)}
          currentBlockIdx={currentBlockIdx}
        />

        <Dropdown
          label="Transition"
          options={["", "Fade"]}
          placeholder="Select"
          selectedValue={singleScreenSettingOption.transition_in}
          onSelect={(value) => {
            handleOptionChange("transition_in", value);
            handleOptionChange("transition_out", value);
          }}
          formatOption={(value) => (value === "" ? "None" : value)}
        />

        {singleScreenSettingOption.transition_in === "Fade" && (
          <>
            <SliderWithInput
              label="Fade In"
              min={0}
              max={3}
              step={0.1}
              value={singleScreenSettingOption.transition_in_duration}
              onChange={(value) =>
                handleOptionChange("transition_in_duration", value)
              }
              currentBlockIdx={currentBlockIdx}
            />
            <SliderWithInput
              label="Fade Out"
              min={0}
              max={3}
              step={0.1}
              value={singleScreenSettingOption.transition_out_duration}
              onChange={(value) =>
                handleOptionChange("transition_out_duration", value)
              }
              currentBlockIdx={currentBlockIdx}
            />
          </>
        )}
      </div>

      <div className="w-full  flex flex-col px-[22px] my-[15px]">
        <SliderWithInput
          label="Delay"
          min={0}
          max={3}
          step={0.1}
          value={singleScreenSettingOption.delay}
          onChange={(value) => handleOptionChange("delay", value)}
          currentBlockIdx={currentBlockIdx}
        />

        <div className="h-[52px] w-full flex justify-between items-center my-2">

          {/* <h2 className="flex items-center text-[#f6f2ff] text-base font-body font-medium w-[70%]">Total Duration</h2> */}
          <div className="ScreenRangeOptionLabel max-w-[70%] cursor-help underline decoration-dashed decoration-[rgba(255,255,255,0.4)] underline-offset-4">Total Duration</div>


          {/* <div className="bg-[#ffffff0a] flex items-center px-2 py-[0.4rem] rounded-md w-[130px] border-[1px] border-[#ffffff1b]">
            <h2 className="flex w-full items-center justify-center text-center">
              {oneScreenDuration}
            </h2>
            <h2>sec</h2>
          </div> */}

          <div 
        // className="bg-[#ffffff0a]  w-[30%] flex justify-between items-center pr-2 rounded-md border-[1px] border-[#ffffff1b]"
        className="w-[30%] flex justify-evenly items-center  resize-none bg-[#ffffff0b] outline-none border-[#ffffff14] border-[1px] rounded-xl text-[#f0eeff] px-[6px] py-[6px] font-normal text-[13px] screen-dd-label"
        >
          <h2 className="text-[#f6f2ff] px-1 w-[50%] py-1 rounded text-center bg-[#ffffff0a] focusN focus:border-transparent focus:outline-none bg-[transparent]"
          >
            {oneScreenDuration}
          </h2>
          <span className="w-[40%]">sec</span>
        </div>


        </div>

        <div className="mt-[6px] py-[11px] px-[14px] rounded-xl flex justify-between items-center  border-[1px] border-[#ffffff08] bg-[#7c5cff14]">
          <div className="font-body text-[13px] text-[#f0eeff]  font-medium">
            Global Settings
          </div>
          <div className="">
            <button onClick={applyToAll} className="global-btn ">
              <AiOutlineGlobal className="text-[1rem]" />
              Apply to all
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ScreenOption;
